import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import { LocationTest } from "./components/admin/LocationTest";
// Auth
import Login from "./components/auth/Login";

// Admin Pages
import Dashboard from "./components/admin/Dashboard";
import Schedule from "./components/admin/Schedule";
import Clients from "./components/admin/Clients";
import Requests from "./components/admin/Requests";
import Quotes from "./components/admin/Quotes";
import Jobs from "./components/admin/Jobs";
import Invoices from "./components/admin/Invoices";
import ProblemReports from "./components/admin/ProblemReports";
import OpenRequests from "./components/admin/OpenRequests";
import Surveyor from "./components/admin/Surveyor";
import OffersManagement from "./components/admin/OffersManagement";
import CashRequests from "./components/admin/CashRequests";
import Reports from "./components/admin/Reports";
import ContactMessages from "./components/admin/ContactMessages";
import Notification from "./components/admin/Notification";
import SurveyorsCashRequests from "./components/admin/SurveyorsCashRequests";
import Category from "./components/admin/Category";
import SubCategory from "./components/admin/SubCategory";
import DashboardDocumentation from "./components/admin/DashboardDocumentation";
import AdminLiveChatDashboard from "./components/admin/AdminLiveChatDashboard";
import TeamMember from "./components/admin/TeamMember";
import LeadSources from "./components/admin/LeadSources";
import UserAgreement from "./components/admin/UserAgreement";
import PaymentsPage from "./components/admin/payments/PaymentsPage";
import AllUsers from "./components/admin/AllUsers";

// Pages
import Settings from "./components/admin/pages/Settings";
import AccountBilling from "./components/admin/pages/AccountBilling";
import ManageTeam from "./components/admin/pages/ManageTeam";

// Create Pages
import CreateClients from "./components/admin/create/CreateClients";
import CreateRequests from "./components/admin/create/CreateRequests";
import CreateQuotes from "./components/admin/create/CreateQuotes";
import CreateNewInvoice from "./components/admin/create/CreateNewInvoice";
import CreateNewJob from "./components/admin/create/CreateNewJob";
import CreateNewTemplate from "./components/admin/create/CreateNewTemplate";
import CreateQuoteJob from "./components/admin/create/CreateQuoteJob";

// Details Pages
import ClientsDetails from "./components/admin/details/ClientsDetails";
import RequestDetails from "./components/admin/details/RequestDetails";
import QuotesDetails from "./components/admin/details/QuotesDetails";
import JobDetails from "./components/admin/details/JobDetails";
import InvoicesDetails from "./components/admin/details/InvoicesDetails";

// User Pages
import UserProfile from "./components/admin/UserProfile";

const AppContent = () => {
  return (
    <>
      <Routes>
        <Route path="/company/login" element={<Login />} />
        <Route
          path="/company/dashboard-documentation"
          element={<DashboardDocumentation />}
        />

        <Route path="/" element={<Navigate to="/company/login" replace />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/profile" element={<UserProfile />}>
            <Route index element={<Dashboard />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="clients" element={<Clients />} />
            <Route path="requests" element={<Requests />} />
            <Route path="quotes" element={<Quotes />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="problem-reports" element={<ProblemReports />} />
            <Route path="open-requests" element={<OpenRequests />} />
            <Route path="surveyor" element={<Surveyor />} />
            <Route path="offers-management" element={<OffersManagement />} />
            <Route path="cash-requests" element={<CashRequests />} />
            <Route path="reports" element={<Reports />} />
            <Route path="contact-messages" element={<ContactMessages />} />
            <Route path="live-chat" element={<AdminLiveChatDashboard />} />
            <Route path="notification" element={<Notification />} />
            <Route
              path="surveyors-cash-requests"
              element={<SurveyorsCashRequests />}
            />
            <Route path="category" element={<Category />} />
            <Route path="sub-category" element={<SubCategory />} />
            <Route path="location-test" element={<LocationTest />} />
            <Route path="lead-sources" element={<LeadSources />} />
            <Route path="user-agreement" element={<UserAgreement />} />
            <Route path="all-users" element={<AllUsers />} />

            {/* Pages */}
            <Route path="user/setting" element={<Settings />} />
            <Route path="user/account" element={<AccountBilling />} />
            <Route path="user/team" element={<ManageTeam />} />
            <Route path="team-member" element={<TeamMember />} />
            {/* Create */}
            <Route path="create/clients" element={<CreateClients />} />
            <Route path="edit/clients/:id" element={<CreateClients />} />
            <Route path="create/requests" element={<CreateRequests />} />
            <Route path="create/new/template" element={<CreateNewTemplate />} />
            <Route path="create/quotes" element={<CreateQuotes />} />
            <Route path="create/jobs" element={<CreateNewJob />} />
            <Route path="create/invoices" element={<CreateNewInvoice />} />
            <Route path="create/quote-job" element={<CreateQuoteJob />} />

            {/* Details */}
            <Route path="details/clients/:id" element={<ClientsDetails />} />
            <Route path="details/requests/:id" element={<RequestDetails />} />
            <Route path="details/quotes/:id" element={<QuotesDetails />} />
            <Route
              path="details/jobs/datatables/:id"
              element={<JobDetails />}
            />
            <Route path="details/invoices/:id" element={<InvoicesDetails />} />
          </Route>
        </Route>
      </Routes>

      <ScrollToTop />
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
